import { Box, Typography } from "@mui/material";
import HumbeeGlassDialog from "../../../v2/MUI_custom_component/Modal/HumbeeGlassDialog";
import { CustomButton } from "../../../v2/MUI_custom_component";

const METHODS = [
  { key: "DIGILOCKER", label: "Digilocker (recommended)", img: 'https://d2djimvzddgguw.cloudfront.net/humbee-NPS/digilocker-app.png' },
  { key: "AADHAAR", label: "Aadhaar", img: 'https://d2djimvzddgguw.cloudfront.net/humbee-NPS/aadhaar-logo.png' },
];

export const DigiLockerKycModal = ({
  open,
  onClose,
  mobileNumber,
  onSelectDigilocker,
  onSelectAadhaar,
  onFillManually,
  loading = false,
}) => {
  const handleSelect = (key) => {
    if (loading) return;
    if (key === "DIGILOCKER") onSelectDigilocker?.();
    else onSelectAadhaar?.();
  };

  return (
    <HumbeeGlassDialog
      open={open}
      onClose={onClose}
      width={{ xs: "400px", md: "600px" }}
      maxWidth={{ xs: "380px", md: "600px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "flex-start", md: "center" },
          gap: 4,
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}>
            <Typography variant="h3" sx={{ textAlign: "center" }}>
              {`Is your mobile number ${mobileNumber} linked with your Aadhaar?`}
            </Typography>
            <Typography
              variant="bodyM"
              sx={{ color: "#333", textAlign: "center" }}>
              Please select to continue.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: { xs: "flex-start", md: "center" },
            }}>
            {METHODS.map((opt) => (
              <Box
                key={opt.key}
                onClick={() => handleSelect(opt.key)}
                sx={{
                  width: { xs: "100%", md: 149 },
                  flex: { xs: 1, md: "none" },
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: loading ? "default" : "pointer",
                  opacity: loading ? 0.5 : 1,
                }}>
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    boxSizing: "border-box",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: "#8C8C8C",
                  }}>
                  <Box
                    component="img"
                    src={opt.img}
                    alt={opt.label}
                    sx={{
                      width: "100%",
                      height: { xs: 140, md: 124 },
                      objectFit: "contain",
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                    }}
                  />
                </Box>
                <Typography
                  variant="bodyM"
                  sx={{ textAlign: "center", color: "#333" }}>
                  {opt.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Typography
          variant="labelD"
          onClick={() => !loading && onFillManually?.()}
          sx={{
            alignSelf: "center",
            color: loading ? "#8C8C8C" : "#333",
            textDecoration: "underline",
            cursor: loading ? "default" : "pointer",
          }}>
          Fill Manually
        </Typography>
      </Box>
    </HumbeeGlassDialog>
  );
};

export default DigiLockerKycModal;
